import { GET_DASHBOARD_DATA, ERROR_GET_DATA, CLOSE_SESION,GET_THE_NEWS_RESPONSE,GET_DASHBOARDBILL_RESPONSE ,PORTAL_SET_IS_BILL} from "../../types";

export default (state, action) => {
try{
  switch (action.type) {
    case GET_DASHBOARD_DATA:
      return {
        ...state,
        data: action.payload,
        sessionExpired: false,
        loading: false,
        terminals: action.payload.taxPayerInfo.terminals,
      };
    case ERROR_GET_DATA:
      return {
        ...state,
        sessionExpired: false,
        error: true,
        /* errorMessage: action.payload, */
        loading: false,
      };
    case CLOSE_SESION: ///FIXME
      localStorage.clear();
      return {
        ...state,
        sessionExpired: true,
        error: false,
        /* errorMessage: action.payload, */
        loading: false,
      };
    case GET_THE_NEWS_RESPONSE:
        const newState = {
          ...state
        }
        //console.table(action)
        return newState
    case GET_DASHBOARDBILL_RESPONSE:
   //   //console.table(action)
        return {
          ...state,
          data:action.payload
        };
    case PORTAL_SET_IS_BILL:
        const ns = {
          ...state,
          isBill:action.payload.isBill
        }
        return ns
    default:
      return state;
  }
  }catch(err){
    //console.table(err)
  }
};
